// @flow

import React, { type Node } from 'react';
import { PixCode } from './pix-code';
import { PixTips } from './pix-tip-box';
import { PixTicket } from './pix-ticket';
import { useReloadAfterPaymentGetItsStatusChanged } from '@tectonics/prs/incoming-payment';

export function PixPendingPage(): Node {
  const refreshInterval = 15000;
  useReloadAfterPaymentGetItsStatusChanged(refreshInterval);
  return (
    <>
      <PixTicket />
      <PixCode />
      <PixTips />
    </>
  );
}
